import { gql } from '@apollo/client';

export const CREATE_COMMAND = gql`
  mutation createCommand($input: CreateCommandInput) {
    createCommand(input: $input) {
      id
      action
      param
    }
  }
`;

export const CREATE_COMMANDS = gql`
  mutation createCommands($input: CreateCommandsInput) {
    createCommands(input: $input) {
      commands {
        action
        id
        param
      }
    }
  }
`;
